import React from 'react';

const STATUS_STYLES = {
  pending: { bg: '#fef3c7', color: '#d97706', label: 'Pending' },
  live: { bg: '#dcfce7', color: '#16a34a', label: 'Live' },
  rejected: { bg: '#fee2e2', color: '#DC143C', label: 'Rejected' },
  approved: { bg: '#dcfce7', color: '#16a34a', label: 'Approved' },
  race: { bg: '#f3f4f6', color: '#6b7280', label: 'Already Approved' },
  edited: { bg: '#fef3c7', color: '#d97706', label: 'Edited' },
};

const StatusBadge = ({ status, small = false }) => {
  const style = STATUS_STYLES?.[status] || STATUS_STYLES?.pending;
  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full ${small ? 'px-1.5 py-0.5 text-xs' : 'px-2.5 py-1 text-xs'}`}
      style={{ backgroundColor: style?.bg, color: style?.color }}
    >
      {style?.label}
    </span>
  );
};

export default StatusBadge;
